import { render } from "./Recipe.vue?vue&type=template&id=88ed6e72"
import script from "./Recipe.vue?vue&type=script&lang=js"
export * from "./Recipe.vue?vue&type=script&lang=js"

import "./Recipe.vue?vue&type=style&index=0&id=88ed6e72&lang=scss"
script.render = render

export default script